import { defineStore } from 'pinia'

export const useUserBalanceStore = defineStore('userBalance', {
    state: () => ({
        balance: 0,
        loading: false,
    }),

    actions: {
        // 获取用户最新余额（每次都请求接口）
        async fetchBalance() {
            this.loading = true
            try {
                const res = await clientFetch('/api/me/get-user-balance', { method: 'GET' })
                if (res.code === 0 && res.data) {
                    this.balance = res.data.balance_coin || 0
                } else {
                    console.warn('获取余额失败:', res)
                }
            } catch (err) {
                console.error('获取余额异常:', err)
            } finally {
                this.loading = false
            }
        },

        // 消费后立即刷新余额
        async refreshBalance() {
            await this.fetchBalance()
        },

        // 本地同步减少余额（即时反馈）
        decrease(amount: number) {
            this.balance = Math.max(0, this.balance - amount)
        },

        // 手动设置余额
        setBalance(value: number) {
            this.balance = value
        },
    },
})
